import { useEffect } from 'react';
import {
  STORAGE_KEY_ACQUISITION_ID,
  STORAGE_KEY_FIRST_TOUCH,
  startOrResumeSession,
  getCampaignContext,
  pushToDataLayer,
  generateId,
} from '@/utils/gtm';

export const GA4Session = () => {
  useEffect(() => {
    const { isNew: isNewSession, id: sessionId } = startOrResumeSession();
    const campaign = getCampaignContext(new URLSearchParams(window.location.search));

    const storedFirstTouch = localStorage.getItem(STORAGE_KEY_FIRST_TOUCH);
    const firstTouch = storedFirstTouch ? (JSON.parse(storedFirstTouch) as typeof campaign) : campaign;

    if (!storedFirstTouch) {
      localStorage.setItem(STORAGE_KEY_FIRST_TOUCH, JSON.stringify(firstTouch));
    }

    const existingAcquisitionId = localStorage.getItem(STORAGE_KEY_ACQUISITION_ID);
    const acquisitionId = existingAcquisitionId ?? generateId('acq');

    if (!existingAcquisitionId) {
      localStorage.setItem(STORAGE_KEY_ACQUISITION_ID, acquisitionId);
    }

    const eventContext = {
      event_timestamp: new Date().toISOString(),
      page_location: window.location.href,
      acquisition_id: acquisitionId,
      zopa_session_id: sessionId,
    };

    if (!existingAcquisitionId) {
      pushToDataLayer({ event: 'acquisition_id_created', ...eventContext, ...campaign });
    } else if (isNewSession && campaign.source !== '' && campaign.source !== firstTouch.source) {
      pushToDataLayer({
        event: 'acquisition_context_updated',
        ...eventContext,
        campaign_id: campaign.campaign_id,
        source: campaign.source,
        medium: campaign.medium,
      });
    }

    if (isNewSession) {
      pushToDataLayer({
        event_timestamp: eventContext.event_timestamp,
        zopa_session_id: sessionId,
        event: 'session_started',
      });
    }
  }, []);

  return null;
};
